import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@/core/services/auth.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * AuthGuard - Protects routes that require authentication
 * Redirects to login if user is not authenticated
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.authService.isAuthenticated().then(isAuthenticated => {
        if (!isAuthenticated) {
          this.router.navigate(['/landing/login']);
          observer.next(false);
        } else {
          observer.next(true);
        }
        observer.complete();
      }).catch(() => {
        this.router.navigate(['/landing/login']);
        observer.next(false);
        observer.complete();
      });
    });
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
